import { I18nService } from '../../services/i18n.service';
import { AdditionalInfoUtil } from '../../utilities/additionalinfo.util';

export class AdditionalInfoMessage {
  title!: string;
  message!: string;
}

export class AdditionalInfoValidation {
  message!: string;
  code!: number;
  validated = false;
}

export class AdditionalInfoType {
  id!: number;
  name!: string;
}

export class AdditionalInfo {
  additionalInfoID?: number;
  objectID!: number;
  equipmentTypeID?: number;
  displayOrder?: number;

  categoryID!: number;
  category!: string;
  disabled!: boolean;
  optional!: boolean;
  fieldType!: string;

  placeholder!: string;

  icon?: boolean;

  // filled for field types single and multiple
  text?: string;
  value?: number;
  valueType?: string;

  minValue?: number;
  maxValue?: number;
  decimals?: number;

  // categorize additional info into different overall types
  infoTypeID?: number;
  infoTypeName?: string;

  // CR 162925 - saves user input without converting it by measurement system
  // A hack to stop rounding errors while users are typing
  valueInProgess: number | null = null;

  // metric vs imperial unit + conversion to meter
  unit?: { mt: string; im: string; md: string } | string;
  unitPrefix?: string;
  conversionFactor?: { mt: number; im: number };

  // filled for field type multiple
  multipleValues?: string[];

  // filled for field type dropdown
  dropdownValues?: string[];

  infoMessage!: AdditionalInfoMessage[];

  // filled for field type radio
  // radioValues?: string[]; // moved into dropdownValues

  // convenience
  currentMeasurementSystem!: string;

  //validations
  showDefault?: boolean;
  textValidation?: boolean;
  showValidation!: boolean;
  validations!: AdditionalInfoValidation[];
  defaultValidation?: AdditionalInfoValidation[];

  get convertedValue(): number | null {
    return AdditionalInfoUtil.getConvertedValue(this);
  }

  set convertedValue(value: number) {
    Object.assign(this, AdditionalInfoUtil.setConvertedValue(this, value));
  }

  labelkey(i18n: I18nService): string {
    return AdditionalInfoUtil.getLabelKey(this, i18n.measureMentSystem(), (text: string) =>
      i18n.parse(text)
    );
  }

  parsedValidationMessage(message: string, i18n: I18nService): string {
    return AdditionalInfoUtil.getParsedValidationMessage(
      this,
      message,
      i18n.measureMentSystem(),
      (text: string) => i18n.parse(text)
    );
  }

  parsedPlaceholder(i18n: I18nService): string {
    return AdditionalInfoUtil.getParsedPlaceholder(this, i18n.measureMentSystem(), (text: string) =>
      i18n.parse(text)
    );
  }

  constructor(obj: Partial<AdditionalInfo>) {
    Object.assign(this, AdditionalInfoUtil.createFromInstance(obj));
  }
}

export interface GroupedAdditionalInfo {
  infoType: AdditionalInfoType;
  infoValues: AdditionalInfo[];
  displayInfoValues: AdditionalInfo[];
}
